/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TIsSpecialistsCatalogAvailableModel,
  IIsSpecialistsCatalogAvailableRequest,
  IMappers,
  IIsSpecialistsCatalogAvailableResponse,
  IIsSpecialistsCatalogAvailableResponseError,
  TIsSpecialistsCatalogAvailableResponse,
} from './types';

const defaultConfig: TIsSpecialistsCatalogAvailableModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'demand',
  pathApi: '/v1/is-specialists-catalog-available/',
  hostType: 'api',
} as TIsSpecialistsCatalogAvailableModel;

function createIsSpecialistsCatalogAvailableModel(
  parameters: IIsSpecialistsCatalogAvailableRequest,
): TIsSpecialistsCatalogAvailableModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IIsSpecialistsCatalogAvailableOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IIsSpecialistsCatalogAvailableRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchIsSpecialistsCatalogAvailable<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IIsSpecialistsCatalogAvailableOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TIsSpecialistsCatalogAvailableResponse
> {
  const { response, statusCode } = await httpApi.fetch(createIsSpecialistsCatalogAvailableModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IIsSpecialistsCatalogAvailableResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IIsSpecialistsCatalogAvailableResponseError);
    }
  }

  return { response, statusCode } as TIsSpecialistsCatalogAvailableResponse;
}

export { defaultConfig, createIsSpecialistsCatalogAvailableModel, fetchIsSpecialistsCatalogAvailable };
